/* Enhance Kaching's rendered cards without replacing its inputs or cart handling. */
(() => {
  const isPrimerPage = document.body.classList.contains('template-product-koko-primer-landingpage-2') || document.body.classList.contains('template-product-koko-line-erase');
  if (!isPrimerPage) return;
  const dealProductImage = document.querySelector('.product-single__media-image img')?.currentSrc || document.querySelector('.product-single__media-image img')?.src || 'https://cdn.shopify.com/s/files/1/0969/6375/6367/files/koko_fine_line.png?width=320';
  const plans = {
    La37: { title: 'Single primer', detail: 'Everyday essential', quantity: 1 },
    xptz: { title: 'Buy 2, get 1 free', detail: '3 primers', quantity: 3, gift: 'Bio-Collagen Mask' },
    Bgif: { title: 'Buy 3, get 3 free', detail: '6 primers', quantity: 6, gift: 'Multi Balm', badge: 'BEST VALUE' }
  };
  function mount(host) {
    if (host.dataset.kokoEnhanced) return;
    host.dataset.kokoEnhanced = 'true';
    let config = {};
    try { config = JSON.parse(host.getAttribute('config') || '{}'); } catch (_) { /* Use store defaults. */ }
    const currency = config.marketCurrencyCode || window.Shopify?.currency?.active || 'AUD';
    const locale = config.moneyFormat?.includes('comma_separator') ? 'nl-NL' : (document.documentElement.lang || 'en');
    const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
    const savingsLabel = amount => currency === 'AUD' ? `A$${amount.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : formatter.format(amount);
    const readAmount = value => {
      const parts = formatter.formatToParts(12345.6);
      const decimal = parts.find(p => p.type === 'decimal')?.value || '.';
      const group = parts.find(p => p.type === 'group')?.value;
      let number = value.replace(/[^\d.,\s]/g, '').replace(/\s/g, '');
      // Kaching can format money using the shop's format rather than the page locale.
      if (/[.,]\d{2}$/.test(number)) {
        number = number.slice(0,-3).replace(/[.,]/g,'') + '.' + number.slice(-2);
      } else { if (group) number = number.split(group).join(''); number = number.replace(decimal,'.'); }
      return Number(number);
    };
    const text = (node,value) => { if (node && node.textContent !== value) node.textContent = value; };
    const ensure = (parent,cls,tag='span') => { let node = parent.querySelector(`.${cls}`); if (!node) { node = document.createElement(tag); node.className=cls; parent.append(node); } return node; };
    const observer = new MutationObserver(update);
    function update() {
      observer.disconnect();
      try {
        host.querySelectorAll('.kaching-bundles__bar').forEach((bar, index) => {
          const plan=plans[bar.dataset.dealBarId] || Object.values(plans)[index];if(!plan)return;
          const main=bar.querySelector('.kaching-bundles__bar-main'),left=bar.querySelector('.kaching-bundles__bar-content-left');if(!main||!left)return;
          text(bar.querySelector('.kaching-bundles__bar-title'),plan.title);
          const originalSubtitle=bar.querySelector('.kaching-bundles__bar-subtitle');if(originalSubtitle)originalSubtitle.hidden=true;
          const amount=readAmount(bar.querySelector('.kaching-bundles__bar-price')?.textContent||'');
          const original=readAmount(bar.querySelector('.kaching-bundles__bar-full-price')?.textContent||'');
          text(ensure(left,'koko-deal-detail'),plan.quantity > 1 && original > amount && amount > 0 ? `Save ${savingsLabel(Math.round((original - amount) * 100) / 100)}` : plan.detail);
          bar.querySelector('.koko-deal-saving')?.remove();
          if(plan.badge)text(ensure(left,'koko-deal-badge'),plan.badge);
          let photo=main.querySelector('.koko-deal-photo');
          if(!photo){
            photo=document.createElement('span');photo.className='koko-deal-photo';photo.dataset.count=String(plan.quantity);
            const copies=plan.quantity===1?1:3;
            for(let i=0;i<copies;i++){const img=document.createElement('img');img.src=dealProductImage;img.alt='';img.width=130;img.height=130;img.style.setProperty('--bottle',i);photo.append(img);}
            const count=document.createElement('small');count.textContent=plan.quantity===1?'1 PRIMER':plan.quantity+' PRIMERS';photo.append(count);
            main.insertBefore(photo,main.querySelector('.kaching-bundles__bar-content'));
          }
          if(plan.gift){text(bar.querySelector('.kaching-bundles__free-gift__text'),`+ ${plan.gift}`);text(bar.querySelector('.kaching-bundles__free-gift__full-price'),'FREE');}
        });
        const selected=host.querySelector('.kaching-bundles__bar--selected');
        const amount=selected?.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
        if(amount){document.querySelectorAll('.koko-balm-buy-price strong').forEach(node=>text(node,amount));}
      } finally { observer.observe(host,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class']}); }
    }
    update();
  }
  const find=()=>document.querySelectorAll('kaching-bundles-block').forEach(mount);
  find();new MutationObserver(find).observe(document.querySelector('#main-content')||document.body,{childList:true,subtree:true});
})();


